import { useContext } from "react";
import { AuthContext } from "../../../context/AuthContext";
import CommonForm from "./CommonForm"

type ServiceType = {
  items: {
    name: string;
    text: string;
  }[]
}


const NewCommonServiceForm = ({ title, items }: { title: string } & ServiceType) => {
  const dataContext = useContext(AuthContext);

  if (!dataContext) return null;
  const { theme } = dataContext;
  return (
    <div className={`${theme === 'dark' ? "bg-primary" : "bg-[#141414]"} transition-all duration-500`}>
      <div className="flex flex-col sm:flex-row justify-between max-w-screen-2xl mx-auto px-5 sm:px-20 py-8 sm:py-28 gap-10 sm:gap-0">
        <div className="sm:w-[50%]">
          <div className="grid gap-10">
            {items.map((item) => (
              <div className="text-white border-b border-white/30">
                <h3 className="bricolage-grotesque-bold mb-4 text-center sm:text-left">{item.name}</h3>
                <p className="font-gtAmerica mb-8 text-center sm:text-left">{ item.text}</p>
              </div>
            ))}
        </div>
        </div>
        <div className="sm:w-[30%]">
          <CommonForm title={title} />
        </div>
      </div>
    </div>
  )
}

export default NewCommonServiceForm